import { Typography } from '@mui/material';
import { Column, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';
import { customerContractTableColumns } from './columns/customer-contract-table-columns';

const defaultColumn: Partial<Column<CustomerContractInventoryGridItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 150,
  minWidth: 50,
  maxWidth: 150,
  align: 'inherit',
};

const getRowId = (row: CustomerContractInventoryGridItem) => row.id;

export function useCustomerContractTableInstance(data: CustomerContractInventoryGridItem[]) {
  return useTable<CustomerContractInventoryGridItem>(
    {
      columns: customerContractTableColumns,
      data,
      initialState: { pageSize: 15 },
      defaultColumn,
      getRowId,
      autoResetFilters: false,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );
}
